<script setup>
import { useI18n } from 'vue-i18n';

const props = defineProps({
  label: {
    type: String,
    default: '',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['change']);

const { t } = useI18n();

const modelValue = defineModel({
  type: Boolean,
  default: false,
});

const updateValue = () => {
  if (props.disabled) return;
  modelValue.value = !modelValue.value;
  emit('change', modelValue.value);
};
</script>

<template>
  <div class="flex items-center gap-2">
    <button
      type="button"
      class="relative h-4 transition-colors duration-200 ease-in-out rounded-full w-7 focus:outline-none focus:ring-1 focus:ring-n-brand focus:ring-offset-n-slate-2 focus:ring-offset-2 flex-shrink-0 disabled:opacity-50 disabled:cursor-not-allowed"
      :class="
        modelValue ? 'bg-n-brand' : 'bg-n-slate-6 disabled:bg-n-slate-6/60'
      "
      role="switch"
      :aria-checked="modelValue"
      :disabled="disabled"
      @click="updateValue"
    >
      <span class="sr-only">{{ t('SWITCH.TOGGLE') }}</span>
      <span
        class="absolute top-0.5 left-0.5 h-3 w-3 transform rounded-full shadow-sm transition-transform duration-200 ease-out"
        :class="
          modelValue
            ? 'translate-x-3 bg-n-background'
            : 'translate-x-0 bg-n-background'
        "
      />
    </button>
    <span
      v-if="label"
      class="text-sm text-n-slate-11 select-none"
      :class="{ 'opacity-50': disabled }"
    >
      {{ label }}
    </span>
  </div>
</template>
